// extracted by mini-css-extract-plugin
export default {"error":"Estancias_error__NZYtO","searchForm":"Estancias_searchForm__hqo31","icon":"Estancias_icon__WJmEf"};